export const withAuthHeader = (params?: object, token?: string | null) => {
  params = params || {};
  return token ? { ...params, headers: { Authorization: `${token}` } } : params;
};
